<template>
  <div class="wrapper">
    <div class="content" ref="brand">
      <div class="title">品牌</div>
      <div class="info">
        <div v-for="(item, index) in baseInfo.brand" :key="index">{{ item.abiBrandDesc }}</div>
      </div>
      <div v-if="baseInfo.brand && baseInfo.brand.length > 4">
        <div v-if="showBrandMoreInfoBtn" class="btn" @click="showMoreInfo(baseInfo.brand, 'brand')">查看更多</div>
        <div v-else class="btn" @click="hideMoreInfo('brand')">收 起</div>
      </div>
    </div>

    <div class="content" ref="subBrand">
      <div class="title">子品牌</div>
      <div class="info">
        <div v-for="(item, index) in baseInfo.subBrand" :key="index">{{ item.abiBrandDesc }}</div>
      </div>
      <div v-if="baseInfo.subBrand && baseInfo.subBrand.length > 4">
        <div v-if="showSubBrandMoreInfoBtn" class="btn" @click="showMoreInfo(baseInfo.subBrand, 'subBrand')">查看更多</div>
        <div v-else class="btn" @click="hideMoreInfo('subBrand')">收 起</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
// 品牌 子品牌 展示
  name: 'perfect-theme-brand',
  props: {
    baseInfo: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      offsetHeightBrand: '',
      offsetHeightSubBrand: '',
      showBrandMoreInfoBtn: true,
      showSubBrandMoreInfoBtn: true
    }
  },
  // mounted () {
  //   this.$nextTick(() => {
  //     })
  // },
  methods: {
    showMoreInfo (arr, type) {
      if (!this.offsetHeightBrand) this.offsetHeightBrand = this.$refs[type].offsetHeight
      if (!this.offsetHeightSubBrand) this.offsetHeightSubBrand = this.$refs[type].offsetHeight
      let offsetHeight = this.offsetHeightBrand || this.offsetHeightSubBrand
      // 一行 4 个元素，数组长度向上取整 则为应有行数
      const height = Math.ceil(arr.length / 4) * offsetHeight
      this.$refs[type].style = `height:${height}px`
      if (type === 'brand') this.showBrandMoreInfoBtn = false
      if (type === 'subBrand') this.showSubBrandMoreInfoBtn = false
    },
    hideMoreInfo (type) {
      this.$refs[type].style = ''
      if (type === 'brand') this.showBrandMoreInfoBtn = true
      if (type === 'subBrand') this.showSubBrandMoreInfoBtn = true
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  background-color: #fff;
  .content {
    display: flex;
    justify-content: flex-start;
    height: 50px;
    line-height: 50px;
    border-bottom: 1px solid #ddd;
    color: #333;
    overflow: hidden;
    transition: height .5s;
    .title {
      // width: 15%;
      flex: none;
      flex-basis: 14%;
      font-size: 16px;
      font-weight: 600;
    }
    .info {
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      flex-basis: 80%;
      height: 50px;
      div {
        // padding-right: 60px;
        // flex: auto;
        min-width: 24%;
      }
    }
    .btn {
      flex: none;
      flex-basis: 6%;
      text-align: right;
      font-size: 12px;
      color: #84b7fb;
      cursor: pointer;
    }
  }
  .content:last-child {
    border-bottom: none;
  }
}
</style>
